function n(e){return e==null}export{n as a};
